import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "content",
  role: "conditions"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " Screening ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "intro" }, [
  /*#__PURE__*/_createTextVNode("Which conditions do you want to screen for? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Select all that apply.")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = { class: "conditions" }
const _hoisted_6 = { class: "bottom-nav" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Next ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " keyboard_double_arrow_right ", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import {  computed, watch } from 'vue';
import { useRouter } from 'vue-router'
import api from '@/api/api'
import Topic from '../components/Topic.vue';
import { TopicModel } from '@/types';
import { useDefaultStore } from "@/store/index"
import { useMsalAuthentication } from '@/msal/useMsalAuthentication'
import { InteractionType } from '@azure/msal-browser'
import { loginRequest } from '@/authConfig';
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {result, acquireToken} = useMsalAuthentication(InteractionType.Redirect, loginRequest)
  const router = useRouter()
  const store = useDefaultStore()
  const getTopics = computed((): TopicModel[] => store.getTopics)
  const openAnalysis = async () => { 
    const data = store.getSelectedTopics
    const response = await api.post('FetchTemplate', {templateKeys: data}, {headers: {'Authorization': 'Bearer ' + result.value?.accessToken}})
    store.setConditionsTemplate(response.data)
    router.push('Clinical')
  } 

  const clear = () => store.clearTopics()

  const callTopicData = async () => {
      const r = await api.get('GetTopics', {headers: {Authorization: 'Bearer ' + result.value?.accessToken}}).catch(() => acquireToken())
      return r.data
  }

  watch((result), async () => {
    const data = await callTopicData()
    store.setTopics(data)
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_unref(getTopics).length === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTopics), (topic, index) => {
        return (_openBlock(), _createBlock(Topic, {
          key: index,
          id: topic.id,
          topicText: topic.topicText,
          selected: topic.selected
        }, null, 8, ["id", "topicText", "selected"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        onClick: _withModifiers(clear, ["prevent"])
      }, "Clear", 8, _hoisted_7),
      _createElementVNode("button", {
        type: "button",
        onClick: _withModifiers(openAnalysis, ["prevent"])
      }, _hoisted_11, 8, _hoisted_8)
    ])
  ]))
}
}

})